const colors = {
  bgBasic: '#008080',
  bgGray: '#BFBFBF',
  bgWhite: '#fff',
  gray: '#999',
  c666: '#666',
};

export default colors;